module.exports = __webpack_public_path__ + "static/media/3.100a32d3.jpg";